<template>
	<div class="login-main">
    <div class="login-box">
      
      <div class="login-under">
        <form>
          <div class="form-group">
            <label for="exampleInputFirstName">First Name</label>
            <input v-model="signup.firstName" class="form-control" id="exampleInputFirstName" aria-describedby="emailHelp" placeholder="Enter First Name">
          </div>
					<div class="form-group">
            <label for="exampleInputLastName">Last Name</label>
            <input v-model="signup.lastName" class="form-control" id="exampleInputLastName" aria-describedby="emailHelp" placeholder="Enter Last Name">
          </div>
					<div class="form-group">
            <label for="exampleInputEmail1">Email</label>
            <input v-model="signup.email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Email">
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Password</label>
            <input v-model="signup.password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
          </div>
          <label align="center" for="exampleInputRole">Role</label><br>
          <div  align="left">
            <!-- <label align="center" for="exampleInputRole">Role</label><br> -->
            <input  v-model="signup.role" type="radio"  id="exampleInputRoleUser" placeholder="Role" value="User" checked >
            <label style="padding-left:10px;" for="exampleInputRole">User</label><br>
            <input  v-model="signup.role" type="radio"  id="exampleInputRoleAdmin" placeholder="Role" value="Admin" >
            <label style="padding-left:10px;"  for="exampleInputRole">Admin </label><br>
          </div>
	
        </form>
        <button class="btn btn-primary w100" @click="onSignUp">Sign Up</button>
        <div><router-link to="/login" class="btn btn-link">Login</router-link></div>
      </div>
      
    </div>
  </div>	
</template>

<script>
/* eslint-disable */
import signup from '../api/signup'
import Login from './Login'

export default {
	name: 'Signup',
	props: {

	},
	components: {
		Login
	},
	data() {
		return {
			signup: {
				firstName: '',
				lastName: '',
				email: '',
        password: '',
        role: ''

			}
		}
	},
	mounted() {

	},
	methods: {
		validateEmail(email) {
      // console.log(">>>>>>")
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
		onSignUp: async function() {
			let emailValidator = await this.validateEmail(this.signup.email)
			let self = this;
			if(self.signup.firstName == ""){
				alert("First Name Required")
				console.log("First name req")
			} else if(self.signup.lastName == ""){
				alert("Last Name Required")
			} else if(self.signup.email == ""){
				console.log("Email required");
				alert("Email Required")
      } else if(emailValidator == false) {
				console.log("Email is not valid", "long");
				alert("Email is not valid")
      } else if (self.signup.password == "") {
				console.log("Password required", "long");
				alert("Password required")
      } else {
        let formdata = {
          "email": self.signup.email,
					"password": self.signup.password,
					"firstname": self.signup.firstName,
          "lastname": self.signup.lastName,
          "role": self.signup.role
        }
        // console.log("Email:", self.signup.email)
        // console.log("Password:", self.signup.password)
        signup.post(formdata).then((response) => {
					// console.log("success")
					alert(response.data.message)
          self.$router.push({
            name: 'Login'
          })
        }).catch((err)=> {
          alert(err.response.data)
          console.log("Error:",err.response.data)
        })  
      }  
    }
	}
}
</script>

<style scoped>
  /* @import '../css/css.css'; */
.login-main {background-color: #e8faff; height: 100vh; width: 100%; text-align: center;}
.login-box {max-width: 360px; width: 100%;  position: relative; top: 50%; left: 50%; transform: translateX(-50%)  translateY(-50%);}
  .login-under {background-color: #fff; border: solid 1px #ccc; padding: 20px 30px;margin-top: 30px;}

</style>